import React from "react";
import PropTypes from "prop-types";
import Tooltip from "../../Tooltip";

WarehouseProductThresholdCountIcon.propTypes = {
  warehouseProduct: PropTypes.shape({
    count: PropTypes.number.isRequired,
    thresholdCountMin: PropTypes.number.isRequired,
    thresholdCountSecure: PropTypes.number.isRequired,
    thresholdCountMax: PropTypes.number.isRequired,
  }).isRequired,
};

export default function WarehouseProductThresholdCountIcon(props){
  const id = 'warehouseProduct-' + props.warehouseProduct.id + '-thresholdCount';
  let icon = null;
  let text = null;

  if(props.warehouseProduct.count <= props.warehouseProduct.thresholdCountMin){
    icon = <i id={id} className="fas fa-battery-quarter text-danger" />;
    text = 'Stan minimalny';
  }else if(props.warehouseProduct.thresholdCountSecure === 0 && props.warehouseProduct.count > props.warehouseProduct.thresholdCountMin){
    icon = <i id={id} className="fas fa-battery-quarter text-warning" />;
    text = 'Stan bezpieczny';
  }else if(props.warehouseProduct.thresholdCountSecure > 0 && props.warehouseProduct.count <= props.warehouseProduct.thresholdCountSecure){
    icon = <i id={id} className="fas fa-battery-half text-warning" />;
    text = 'Stan bezpieczny';
  }else if(props.warehouseProduct.thresholdCountMax === 0 && props.warehouseProduct.count > props.warehouseProduct.thresholdCountSecure){
    icon = <i id={id} className="fas fa-battery-full text-success" />;
    text = 'Stan maksymalny';
  }else if(props.warehouseProduct.thresholdCountMax > 0 && props.warehouseProduct.count <= props.warehouseProduct.thresholdCountMax){
    icon = <i id={id} className="fas fa-battery-full text-success" />;
    text = 'Stan maksymalny';
  }else if(props.warehouseProduct.thresholdCountMax > 0 && props.warehouseProduct.count > props.warehouseProduct.thresholdCountMax){
    icon = <i id={id} className="fas fa-battery-full text-danger" />;
    text = 'Stan maksymalny przekroczony';
  }

  if(props.warehouseProduct.thresholdCountMin === 0 && props.warehouseProduct.thresholdCountSecure === 0 && props.warehouseProduct.thresholdCountMax === 0){
    text = null;

    if(props.warehouseProduct.count <= 0){
      icon = <i id={id} className="fas fa-battery-quarter text-danger" />;
    }else{
      icon = <i id={id} className="fas fa-battery-full text-success" />;
    }
  }

  if(props.warehouseProduct.count === 0){
    icon = <i id={id} className="fas fa-battery-empty text-danger" />;
    text = 'Brak na stanie';
  }

  return <React.Fragment>
    {icon}
    {text && <Tooltip id={id} msg={text}/>}
  </React.Fragment>
}